export const allFeatureFlags = [
  'showMedicalRecord',
  'showSitesSelectionAssistant',
  'sponsorUsersWithAdminRoleForAlnylamTrial',
  'sitesCanAddExternalTrialsForPatientId',
  'nextStepsNewStatusForPatientTrialMatch',
  'sitesAreFinanciallyIncentivizedToPreScreenOnInatoTrials',
  'fastTriageV2SecondRelease',
  'showSliderWithHistogramFilter',
  'improveEnrollmentProgressReporting',
  'disableEnrollmentProgressUpdate',
] as const;

export type FeatureFlag = (typeof allFeatureFlags)[number];
